export default{
    namespaced: true,
    state: {
      //navigation modals
        sidebar: {
          isSidebarVisible: false,
          isCollapsed: false,
          isMobile: false
        },
      //general modals
        contact: false,
      //account modals
        login: false,
        logout: false,
        register: false,
        restore: false,
        password: false,
        phone: false,
        email: false,
        addTruck: false,
        editTruck: false,
        addDriver: false,
        editDriver: false,
        addBay: false,
        editBayName: false,
        addServiceOrder: false,
        editServiceOrder: false,
        finishServiceOrder: false
    },
    getters: {
    },
    mutations: {
      showModal(state, payload) {
        state[payload] = true;
      },
      hideModal(state, payload) {
        state[payload] = false;
      },
      toggleModal(state, modal) {
        if (typeof modal === 'object' && modal.name) {
          state[modal.name] = modal.value !== undefined ? modal.value : !state[modal.name];
        } else {
          state[modal] = !state[modal];
        }
      },
      toggleCollapse(state) {
        state.sidebar.isCollapsed = !state.sidebar.isCollapsed;
      },
      setSidebarCollapsed(state, isCollapsed) {
        state.sidebar.isCollapsed = isCollapsed;
      },
      setSidebarMobile(state, isMobile) {
        state.sidebar.isMobile = isMobile;
      },
      toggleSidebar(state) {
        state.sidebar.isSidebarVisible = !state.sidebar.isSidebarVisible;
      },
      setSidebarVisible(state, isVisible) {
        state.sidebar.isSidebarVisible = isVisible;
      },
      closeAllModals(state) {
        Object.keys(state).forEach(key => {
          state[key] = false;
        });
      }
    },
    actions: {
    },
    modules: {
    }
  }
